import styled from 'styled-components'
import {Link} from 'react-router-dom'

export const Wrapper = styled.tr(({theme}) => ({
  fontSize: theme.fontSizes.small,
  fontWeight: 700,
  transitionDuration: '200ms',
  '&:hover': {
    transform: 'scale(1.01)',
    [TdInner]: {
      background: theme.colors.bgPaper,
    },
  },
}))

export const CurrencyWrapper = styled.div(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  '& > span': {
    marginLeft: '0.75em',
    display: 'inline-block',
  },
}))

export const ActionsWrapper = styled.div(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
}))

export const Td = styled.td(({theme}) => ({
  padding: '5px 0',
  whiteSpace: 'nowrap',
  '&:first-child': {
    [TdInner]: {
      borderLeftWidth: 1,
      borderBottomLeftRadius: theme.sizes.radii.small,
      borderTopLeftRadius: theme.sizes.radii.small,
    },
  },
  '&:last-child': {
    [TdInner]: {
      borderRightWidth: 1,
      borderBottomRightRadius: theme.sizes.radii.small,
      borderTopRightRadius: theme.sizes.radii.small,
    },
  },
}))

export const TdInner = styled.div(({theme}) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  background: theme.colors.bgBody,
  borderColor: theme.colors.border,
  borderStyle: 'solid',
  borderWidth: '1px 0',
  padding: '5px 10px',
  minHeight: 50,
  transitionDuration: '200ms',
}))

export const TdLink = styled(Link)`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
`

export const ComingSoonText = styled.div(({theme}) => ({
  textAlign: 'center',
  color: theme.colors.primary,
  width: '100%',
  fontWeight: 700,
}))

export const SmallText = styled.div(({theme}) => ({
  fontSize: theme.fontSizes.extraSmall,
  fontWeight: 500,
  color: theme.colors.textSecondary,
}))
